import {MutationTree} from "vuex";
import {EnterpriseMutationTypes, EnterpriseState} from "@/store/enterprise/types";

const mutations: MutationTree<EnterpriseState> = {
    [EnterpriseMutationTypes.setOldestStoppedTime]: (state, dateTIme: Date) => {
        state.oldestStoppedTime = dateTIme;
    }
}

export default mutations;